import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class ImageInformationV4 extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        ImageInformation Web Service (Version 4)
                    </h1>
                    <h2 className="main-subheading">ImageInformation</h2>
                    <div className="technical-main-content">
                        <p>The ImageInformation method is typically used by the Service Aggregator to check the status of a card design.
                            The Aggregator should wait until the card design submitted by the Cardholder is Accepted before sending an
                            embossing record to the Bureau. If the card design is Denied, the Service Aggregator should trigger the
                            appropriate business procedure to deal with such cases (for example, issue the Cardholder with a standard
                            plastic).
                    </p>
                        <h3>WSDL URL</h3>
                        <p>Thales will provide the WSDL URL for DevServer during the project.</p>
                        <br />

                        <h3>Request Parameters</h3>
                        <ul>
                            <li><b>CardImageID</b> (string)
                        <p>The unique identifier for the image being requested, This is generated by the Designer Website and passed to the Subscriber during the Handback procedure.</p>
                            </li>
                            <li><b>ImageInformation_Key</b> (GUID string)
                        <p>This value identifies the caller and is matched to the Service Aggregator. This guarantees that the caller should have access to the requested CardImageID.
                                    Thales will provide the Aggregator with the value for this parameter. Also note that a different value will be used on each environment (see the Handover URL section for an explanation of the environments).</p>
                            </li>
                        </ul>
                        <br />
                        <h3>Response Paramters (<span >New parameters are in red</span>)</h3>
                        <ul>
                            <li><b>CardImageID</b> (string)
                        <p>The same value as the request parameter.</p>
                            </li>
                            <li><b>DesignState</b> (integer)
                        <p>Identifies the current state of the requested card design.</p>
                            </li>
                            <li><b>ErrorCode</b> (integer)
                        <p>An error code describing the error (if any) that occurred during the method call.</p>
                            </li>
                            <li><b>Handover_Key</b> (GUID string)
                        <p>the Handover_Key that was used to create the card design in the Designer Website.</p>
                            </li>
                            <li><b>RejectionReason</b> (string)
                        <p>If the image was rejected in image checking then this will display the reason for the rejection decision. Will be left blank if the image is accepted.</p>
                            </li>
                            <li><b>ImageType</b> (string)
                        <p>The type of image that was submitted; custom, gallery and unknown</p>
                            </li>
                            <li><b>TransactionApprovalState</b> (string)
                        <p>If Transaction Approval option is configured for the product, this will identify whether or not the transaction has been approved for this image.
                                            If no approval decision has been made on the image then this will be an empty string.
                                    If Transaction Approval is not configured for the product then this will always be an empty string.</p>
                            </li>
                            <li><b><span >StockImageCode</span></b> (string)
                        <p>This relates to the Price Code set up within gallery management of the PCS Administration site.</p>
                            </li>
                            <li><b><span >CardPrinted</span></b> (dateTime)
                        <p>Deprecated - The date and time that the card was printed.</p>
                            </li>
                            <li><b><span >CardMailed</span></b> (dateTime)
                        <p>Deprecated - The date and time that the card was mailed.</p>
                            </li>
                            <li><b><span >ImageCheckingStartTimeStamp</span></b> (dateTime)
                        <p>This identifies the date and time when an image was first image checked.</p>
                            </li>
                            <li><b><span >ImageCheckingEndTimeStamp</span></b> (dateTime)
                        <p>The date and time the image checking decision is made. This is subject to the “hold period” of an
                                        image expiring. The hold period is a configurable timeframe (usually 2 hours) that begins when an
                                image is accepted by image checking, this provides a grace period so that the decision can be overturned.</p>
                            </li>
                            <li><b><span >TransactionApprovalStateName</span></b> (string)
                        <p>This indicates the current state of transaction approvals name.</p>
                            </li>
                            <li><b><span >TransactionApprovalStateID</span></b> (integer)
                        <p>This indicates the current state of transaction approval state id.</p>
                            </li>
                            <li><b><span >TransactionApprovalTimeStamp</span></b> (datetime)
                    <p>This indicates date and time the client transaction approved the design.</p>
                            </li>
                            <li><b><span >TransactionApprovalComment</span></b> (string)
                    <p>This indicates a comment provided with the transaction approval to indicate the reason for or against approving a design.</p>
                            </li>
                            <li><b><span >AggregatorName</span></b> (string)
                        <p>This identifies the company acquiring this service.</p>
                            </li>
                            <li><b><span >AggregatorID</span></b> (integer)
                        <p>The unique identifier for the Aggregator.</p>
                            </li>
                            <li><b><span >SubscriberName</span></b> (string)
                        <p>This identifies the customers obtaining the service offered by the Aggregator.</p>
                            </li>
                            <li><b><span >SubscriberID</span></b> (interger)
                        <p>The unique identifier for the Subscriber.</p>
                            </li>
                            <li><b><span >ProductName</span></b> (string)
                        <p>This identifies the card template e.g Classic, Gold or Platinum.</p>
                            </li>
                            <li><b><span >ProductID</span></b> (interger)
                        <p>The unique identifier of a product.</p>
                            </li>
                            <li><b><span >DesignCreatedTimeStamp</span></b> (dateTime)
                        <p>This identifies the date and time a design was created in the designer website.</p>
                            </li>
                            <li><b><span >DesignStateTimeStamp</span></b> (dateTime)
                        <p>Identifies the date and time of the requested card design in it&apos;s current state.</p>
                            </li>
                            <li><b><span >DesignStateName</span></b> (string)
                        <p>Identifies the name of the current state of the requested card design.</p>
                            </li>
                            <li><b><span >DesignStateID</span></b> (interger)
                        <p>This is a unique identifier of the current state of the requested card design.</p>
                            </li>
                            <li><b><span >DesignTransferStateName</span></b> (string)
                        <p>Identifies the progress status of a requested card design, it identifies whether the requested card design has been transferred, still in queue, if the transfer errored or it&apos;s in the middle of a tranfer.</p>
                            </li>
                            <li><b><span >DesignTransferStateID</span></b> (integer)
                        <p>This is the value that identifies the design transfer state of a requested card design.</p>
                            </li>
                            <li><b><span >DesignTransferTimeStamp</span></b> (dateTime)
                        <p>This identifies the date and time a requested card design is transferred.</p>
                            </li>
                            <li><b><span >EmailAddress</span></b> (string)
                        <p>This identifies where users will be sent an email notifying them of the decisions regarding their submitted designs.</p>
                            </li>
                            <li><b><span >EmailSent</span></b> (boolean)
                        <p>This identifies whether or not an email has been sent. This will return &quot;true&quot; or &quot;false&quot;.</p>
                            </li>
                            <li><b><span >LanguageId</span></b> (string)
                        <p>This indicates the language used if the subscriber is multi lingual.</p>
                            </li>
                            <li><b><span >PublicImage</span></b> (boolean)
                        <p>Identifies whether a design should be made public. This will return &quot;true&quot; or &quot;false&quot;.</p>
                            </li>
                            <li><b><span >ClientRefererId</span></b> (string)
                        <p>This refers to another design image created by a previous customer. Normally used with ShareMyDesign and Social Card.</p>
                            </li>
                            <li><b><span >TransferredDefaultImage</span></b> (boolean)
                        <p>This is the default image that will be sent if an image was rejected.</p>
                            </li>
                            <li><b><span >BatchFileName</span></b> (string)
                        <p>This identifies the filename assigned to a batch file.</p>
                            </li>
                            <li><b><span >BatchFileTimeStamp</span></b> (dateTime)
                        <p>This indicates the date and time the batch file was sent.</p>
                            </li>
                            <li><b><span >Processed</span></b> (dateTime)
                        <p>This indicates whether a batch file has been sent.</p>
                            </li>
                            <li><b><span >DataFields</span></b> (collection)
                        <p>All the DataCature Fields that are assigned to the product. This is a dynamic and can change
                            dependant on how the data capture parameters are configured with program management.</p>
                            </li>
                            <li><b><span >Data</span></b> (record)
                        <p> Id (string) [attribute] <br />
                                    Value (string) [attribute]</p>
                            </li>
                            <li><b><span >CustomImagePricePoint</span></b> (string) <b></b>
                                <p>Deprecated</p></li>
                            <li><b><span >TextLayerPricePoint</span></b>(string) <b></b>
                                <p>Deprecated</p>
                            </li>
                        </ul>
                    </div>
                    <br />
                    <div className="document-content-back">
                        <Link className="document-content-link" to='/technical/imageinformation'>Back</Link>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        )
    }
}

export default ImageInformationV4;